// extracted by mini-css-extract-plugin
export var subpageHeaderBar = "subpageHeaderBar-module--subpageHeaderBar--p3o7f";